var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticStyle:{"background-color":"#C7DCF0"},attrs:{"size":_vm.size}},[_c('span',{staticClass:"initials-icon"},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }